var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-inline--fa fa-fw",
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 1.16666V12.8333M10.8334 6.99999H0.833374M0.833374 6.99999L3.33337 9.49999M0.833374 6.99999L3.33337 4.49999",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default "data:image/svg+xml;base64,PHN2ZyBjbGFzc05hbWU9InN2Zy1pbmxpbmUtLWZhIGZhLWZ3IiB2aWV3Qm94PSIwIDAgMTUgMTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xNC4xNjY3IDEuMTY2NjZWMTIuODMzM00xMC44MzM0IDYuOTk5OTlIMC44MzMzNzRNMC44MzMzNzQgNi45OTk5OUwzLjMzMzM3IDkuNDk5OTlNMC44MzMzNzQgNi45OTk5OUwzLjMzMzM3IDQuNDk5OTkiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };